angular.module('clientDashboardApp')
  .filter('ordinal', function() {
    return function(input) {
      let mapper = ['th','st','nd','rd','th','th','th','th','th','th']
      let asString = input.toString()
      let tenThruTwenty = asString.length > 1 && parseInt(asString.substr(-2)) >= 10 && parseInt(asString.substr(-2)) < 20
      return  tenThruTwenty ? input+'th' : input+mapper[parseInt(asString.substr(-1))]
    };
  })
